import { post,get } from "./http";
import common from './constants';
let basic = common.interfacePath.serverTestUrl;
// let orderBasic = basic + '/order';

const planSaleApi = {
	// //大厅商品搜索
  getSearchProduct: (params) => {
    return post(`/list/search`, params);
  }, //大厅商品详情
  getProductDetail: (params) => {
    return get(`/list/searchDetail`, params);
  },
  //产品分类接口  
  getCategoryTreeData: (params) => { 
    return post('/product/getCategoryTreeData', params);
  },
  //获取挂牌仓库价格
  getPriceByStockId: (params) => { 
    return get('/price/getPriceByStockId', params) 
  }, 
  //创建订单预览
  getOrderPreview: (params) => { return  post(`/order/createOrderPreview`, params) },
  //提交订单 
  submitOrder: (params) => { return post(`/order/submitOrder`, params) },
  // 协议
  getAgreement: (params) => {
    return post(`/merchant/listAgreement`, params);
  }, 
  //发货地点配置
  getOrderConfig:(params) => { return post(`list/deliveryConfig`, params)},
  //买家销售计划-获取买家对应的卖家列表  
  getSellerList: (params) => { return post(`${basic}/planMothSalesBuyer/getSellerList`, params)},  
  
};
export default planSaleApi;